/** Excel içe aktarma — panel açık tema SSOT */

import { PANEL } from "./panelTokens";
import { panelPrimaryButtonSx, panelListTableSx, panelListTableContainerSx, panelChipPositiveSx } from "./panelCardSx";
import { panelPageTitleSx } from "./panelPageHeaderSx";
import { panelDialogSecondaryButtonSx } from "./panelDialogSx";
import { panelFormFieldSx } from "./panelFormSx";
import { panelCollaborationGuidePaperSx, panelCollaborationGuideTitleSx, panelCollaborationGuideBodySx } from "./panelCollaborationSx";

export { panelCollaborationGuidePaperSx, panelCollaborationGuideTitleSx, panelCollaborationGuideBodySx };

/** FieldSelectionModal — legacy colors API uyumluluk katmanı */
export const panelFieldSelectionColorsShim = {
  grey: {
    100: PANEL.text.primary,
    200: PANEL.text.body,
    300: PANEL.text.muted,
    400: PANEL.text.muted,
    500: PANEL.text.label,
    700: PANEL.border,
    800: PANEL.border,
  },
  primary: {
    400: PANEL.fill.muted,
    500: PANEL.surface,
    600: PANEL.fill.muted,
    700: PANEL.fill.subtle,
    800: PANEL.pageBg,
    900: PANEL.text.primary,
  },
  blueAccent: { 400: PANEL.blue.text, 700: PANEL.blue.main, 800: PANEL.blue.soft },
  redAccent: { 400: PANEL.danger.main, 700: PANEL.danger.main },
  red: { 500: PANEL.danger.main },
  greenAccent: { 400: PANEL.accent.main, 700: PANEL.accent.text },
};

export const panelExcelImportPageTitleSx = {
  color: PANEL.text.primary,
  fontWeight: 700,
  fontSize: { xs: "1.25rem", sm: "1.375rem" },
  lineHeight: 1.35,
};

export const panelExcelImportSectionTitleSx = {
  color: PANEL.text.primary,
  fontWeight: 600,
  fontSize: { xs: "1.0625rem", sm: "1.125rem" },
  lineHeight: 1.4,
};

export const panelExcelImportBodyTextSx = {
  color: PANEL.text.body,
  fontSize: "1rem",
  lineHeight: 1.7,
  fontWeight: 400,
};

export const panelExcelImportSecondaryTextSx = {
  color: PANEL.text.muted,
  fontSize: "0.9375rem",
  lineHeight: 1.65,
  fontWeight: 400,
};

export const panelExcelImportHintLabelSx = {
  color: PANEL.text.meta,
  fontSize: "0.875rem",
  lineHeight: 1.5,
  fontWeight: 600,
};

export const panelExcelImportHintListSx = {
  color: PANEL.text.muted,
  fontSize: "0.875rem",
  lineHeight: 1.55,
  fontWeight: 400,
};

export const panelExcelImportKickerSx = {
  color: PANEL.accent.text,
  fontSize: "0.6875rem",
  letterSpacing: "0.05em",
  fontWeight: 600,
  lineHeight: 1.4,
  textTransform: "none",
};

export const panelExcelImportCardSx = {
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  borderRadius: PANEL.radius.card,
  boxShadow: PANEL.shadow.card,
  overflow: "hidden",
};

export const panelExcelImportFlowCardSx = (recommended = false) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  textAlign: "left",
  p: { xs: 2.25, md: 2.75 },
  minHeight: { md: 240 },
  cursor: "pointer",
  borderRadius: PANEL.radius.cardMd,
  border: `1px solid ${recommended ? PANEL.accent.softBorder : PANEL.border}`,
  bgcolor: recommended ? PANEL.accent.soft12 : PANEL.surface,
  boxShadow: PANEL.shadow.card,
  transition: "box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease",
  font: "inherit",
  "&:hover": {
    borderColor: PANEL.accent.softBorder,
    boxShadow: PANEL.shadow.cardHover,
    transform: "translateY(-2px)",
  },
});

/** PatientVision hub kartları — teal (şablon) / mavi (yükleme) */
export const PANEL_EXCEL_USAGE_CARDS = {
  define: {
    accent: PANEL.accent.main,
    accentGlow: PANEL.accent.focusRing,
    gradient: `linear-gradient(135deg, ${PANEL.accent.soft} 0%, ${PANEL.surface} 72%)`,
    border: PANEL.accent.softBorder22,
    badgeBg: PANEL.accent.soft,
    badgeText: PANEL.accent.text,
  },
  import: {
    accent: PANEL.blue.main,
    accentGlow: PANEL.blue.soft25,
    gradient: `linear-gradient(135deg, ${PANEL.blue.soft} 0%, ${PANEL.surface} 72%)`,
    border: PANEL.blue.soft25,
    badgeBg: PANEL.blue.chipBg,
    badgeText: PANEL.blue.text,
  },
};

export const panelExcelImportHeroSx = {
  mb: 2.5,
};

export const panelExcelImportHeroIconSx = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  background: `linear-gradient(135deg, ${PANEL.accent.main} 0%, ${PANEL.blue.main} 100%)`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: PANEL.accent.shadow25,
  flexShrink: 0,
  color: PANEL.surface,
  "& .MuiSvgIcon-root": { fontSize: "1.6rem", color: PANEL.surface },
};

export const panelExcelImportHeroTitleSx = {
  ...panelPageTitleSx,
};

export const panelExcelImportHeroChipSx = {
  fontWeight: 700,
  fontSize: "0.72rem",
  bgcolor: PANEL.accent.soft,
  color: PANEL.accent.text,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  borderRadius: "6px",
};

export const panelExcelImportHeroSubtitleSx = {
  color: PANEL.text.body,
  fontSize: { xs: "0.88rem", sm: "0.95rem" },
  lineHeight: 1.7,
  mb: 2,
  maxWidth: 1080,
};

export const panelExcelImportHeroPillSx = {
  bgcolor: PANEL.fill.muted,
  color: PANEL.text.body,
  border: `1px solid ${PANEL.border}`,
  borderRadius: "8px",
  height: "auto",
  py: 0.5,
  px: 0.5,
  fontWeight: 600,
  fontSize: "0.78rem",
  "& .MuiChip-icon": { color: PANEL.accent.text },
  "& .MuiChip-label": { whiteSpace: "normal" },
};

export const panelExcelImportUsageCardSx = (tone = "define") => {
  const theme = PANEL_EXCEL_USAGE_CARDS[tone] || PANEL_EXCEL_USAGE_CARDS.define;
  return {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    p: { xs: 2, sm: 2.5 },
    borderRadius: PANEL.radius.card,
    background: theme.gradient,
    border: `1px solid ${theme.border}`,
    boxShadow: "0 4px 20px rgba(148, 163, 184, 0.12)",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      transform: "translateY(-4px)",
      borderColor: theme.accent,
      boxShadow: `0 12px 28px ${theme.accentGlow}`,
    },
  };
};

export const panelExcelImportUsageCtaSx = (tone = "define") => {
  const theme = PANEL_EXCEL_USAGE_CARDS[tone] || PANEL_EXCEL_USAGE_CARDS.define;
  return {
    bgcolor: theme.accent,
    color: PANEL.surface,
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.85rem",
    py: 0.8,
    minHeight: 40,
    borderRadius: "10px",
    boxShadow: "none",
    "&:hover": {
      bgcolor: theme.accent,
      opacity: 0.92,
      boxShadow: "none",
    },
  };
};

export const panelExcelImportNoteCardSx = {
  height: "100%",
  p: 1.75,
  borderRadius: PANEL.radius.input,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
  boxShadow: PANEL.shadow.card,
};

export const panelExcelImportHowItWorksSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(3, minmax(0, 1fr))" },
  gap: 1.25,
};

export const panelExcelImportHowItWorksItemSx = {
  display: "flex",
  gap: 1.25,
  alignItems: "flex-start",
  p: 1.75,
  borderRadius: PANEL.radius.cardMd,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
  boxShadow: PANEL.shadow.card,
};

export const panelExcelImportIndexBadgeSx = {
  width: 28,
  height: 28,
  borderRadius: "8px",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: PANEL.accent.soft,
  color: PANEL.accent.text,
  fontWeight: 700,
  fontSize: "0.8125rem",
  lineHeight: 1,
};

export const panelExcelImportFlowCtaSx = {
  mt: "auto",
  pt: 2.25,
  fontWeight: 700,
  fontSize: "0.875rem",
  color: PANEL.accent.text,
};

export const panelExcelImportRecommendedChipSx = {
  mb: 1.25,
  height: 22,
  fontSize: "0.6875rem",
  fontWeight: 700,
  letterSpacing: "0.02em",
  bgcolor: PANEL.accent.soft,
  color: PANEL.accent.text,
  border: `1px solid ${PANEL.accent.softBorder22}`,
};

export const panelExcelImportJobHistoryAccordionSx = {
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  borderRadius: `${PANEL.radius.card} !important`,
  boxShadow: PANEL.shadow.card,
  overflow: "hidden",
  "&:before": { display: "none" },
};

export const panelExcelImportTableContainerSx = {
  ...panelListTableContainerSx,
  mt: 1,
};

export const panelExcelImportTableHeadCellSx = {
  ...panelListTableSx["& .MuiTableHead-root .MuiTableCell-root"],
};

export const panelExcelImportTableSx = panelListTableSx;

export const panelExcelImportDropzoneSx = (isDragging = false) => ({
  border: `2px dashed ${isDragging ? PANEL.accent.main : PANEL.border}`,
  borderRadius: PANEL.radius.cardMd,
  bgcolor: isDragging ? PANEL.accent.soft : PANEL.fill.muted,
  p: { xs: 3, md: 4.5 },
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: PANEL.accent.softBorder,
    bgcolor: PANEL.accent.soft12,
  },
});

export const panelExcelImportFilePreviewSx = {
  mt: 2.5,
  p: 2,
  borderRadius: PANEL.radius.input,
  bgcolor: PANEL.accent.soft,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  display: "flex",
  alignItems: "center",
  gap: 2,
};

export const panelExcelImportMappingCardSx = (isMapped = false) => ({
  p: 2,
  borderRadius: PANEL.radius.input,
  border: `1px solid ${isMapped ? PANEL.accent.softBorder : PANEL.border}`,
  bgcolor: isMapped ? PANEL.accent.soft12 : PANEL.surface,
  borderLeft: `4px solid ${isMapped ? PANEL.accent.main : PANEL.border}`,
  boxShadow: isMapped ? PANEL.accent.shadow25 : "none",
  transition: "border-color 0.2s ease, background-color 0.2s ease",
});

export const panelExcelImportMappedChipSx = {
  ...panelChipPositiveSx,
  maxWidth: "100%",
  height: "auto",
  minHeight: 32,
  "& .MuiChip-label": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    display: "block",
    py: 0.5,
  },
};

export const panelExcelImportUnmappedChipSx = {
  bgcolor: PANEL.fill.muted,
  color: PANEL.text.muted,
  border: `1px solid ${PANEL.border}`,
  fontWeight: 600,
  maxWidth: "100%",
  height: "auto",
  minHeight: 32,
  "& .MuiChip-label": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    display: "block",
    py: 0.5,
  },
};

export const panelExcelImportPrimaryButtonSx = {
  ...panelPrimaryButtonSx,
  px: 4,
  py: 1.1,
  fontSize: "0.9375rem",
};

export const panelExcelImportSecondaryButtonSx = panelDialogSecondaryButtonSx;

export const panelExcelImportBackButtonSx = {
  color: PANEL.text.muted,
  fontSize: "0.875rem",
  fontWeight: 500,
  textTransform: "none",
  "&:hover": {
    color: PANEL.text.primary,
    bgcolor: PANEL.fill.muted,
  },
};

export const panelExcelImportStepperSx = {
  "& .MuiStepLabel-root .Mui-completed": { color: PANEL.accent.main },
  "& .MuiStepLabel-root .Mui-active": { color: PANEL.accent.main },
  "& .MuiStepIcon-root.Mui-active": { color: PANEL.accent.main },
  "& .MuiStepIcon-root.Mui-completed": { color: PANEL.accent.main },
  "& .MuiStepConnector-line": { borderColor: PANEL.border },
  "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": { borderColor: PANEL.accent.main },
  "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": { borderColor: PANEL.accent.main },
  "& .MuiStepLabel-label": {
    color: `${PANEL.text.muted} !important`,
    fontSize: "0.875rem !important",
    fontWeight: "500 !important",
  },
  "& .MuiStepLabel-label.Mui-active": {
    color: `${PANEL.text.primary} !important`,
    fontWeight: "600 !important",
  },
  "& .MuiStepLabel-label.Mui-completed": {
    color: `${PANEL.accent.text} !important`,
  },
};

export const panelExcelImportProgressSx = {
  mb: 2,
  borderRadius: PANEL.radius.chip,
  height: 3,
  bgcolor: PANEL.accent.soft12,
  "& .MuiLinearProgress-bar": { bgcolor: PANEL.accent.main },
};

export const panelExcelImportFormControlSx = {
  ...panelFormFieldSx,
  mb: 2,
};

export const panelExcelImportJobStatusChipSx = (status) => {
  if (status === "completed") {
    return { bgcolor: PANEL.accent.soft12, color: PANEL.accent.text, border: `1px solid ${PANEL.accent.softBorder22}` };
  }
  if (status === "processing") {
    return { bgcolor: PANEL.blue.soft12, color: PANEL.blue.text, border: `1px solid ${PANEL.blue.soft25}` };
  }
  if (status === "failed") {
    return { bgcolor: PANEL.danger.soft, color: PANEL.danger.text, border: `1px solid ${PANEL.danger.border}` };
  }
  return { bgcolor: PANEL.fill.muted, color: PANEL.text.muted, border: `1px solid ${PANEL.border}` };
};

export const panelExcelImportIntroPaperSx = {
  position: "relative",
  overflow: "hidden",
  mb: 2.5,
  borderRadius: PANEL.radius.card,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
  boxShadow: PANEL.shadow.card,
};

export const panelExcelImportIntroFeatureSx = (tone = "accent") => ({
  height: "100%",
  p: 1.75,
  borderRadius: PANEL.radius.input,
  border: `1px solid ${tone === "blue" ? PANEL.blue.soft25 : PANEL.accent.softBorder22}`,
  bgcolor: tone === "blue" ? PANEL.blue.soft : PANEL.accent.soft,
});

export const panelExcelImportGuideBoxSx = (variant = "info") => ({
  p: { xs: 2, sm: 2.5 },
  mb: 2,
  borderRadius: PANEL.radius.cardSm,
  border: `1px solid ${variant === "tip" ? PANEL.blue.soft25 : PANEL.accent.softBorder22}`,
  borderLeft: `4px solid ${variant === "tip" ? PANEL.blue.text : PANEL.accent.main}`,
  bgcolor: variant === "tip" ? PANEL.blue.soft : PANEL.accent.soft,
});

export const panelExcelImportCreatePatientsSx = (checked = true) => ({
  p: { xs: 1.75, sm: 2 },
  mb: 2,
  borderRadius: PANEL.radius.cardSm,
  border: `2px solid ${checked ? PANEL.accent.softBorder : PANEL.warning.border}`,
  bgcolor: checked ? PANEL.accent.soft : PANEL.warning.soft,
  boxShadow: "none",
});

export const panelFieldSelectTabsSx = {
  minHeight: 48,
  "& .MuiTabs-indicator": {
    height: 3,
    borderRadius: "3px 3px 0 0",
    bgcolor: PANEL.accent.main,
  },
  "& .MuiTab-root": {
    color: PANEL.text.muted,
    fontSize: "0.8125rem",
    fontWeight: 600,
    textTransform: "none",
    minHeight: 48,
    minWidth: 0,
    px: 1.5,
  },
  "& .MuiTab-root.Mui-selected": {
    color: PANEL.accent.text,
    fontWeight: 700,
  },
};

export const panelFieldSelectListItemSx = {
  borderRadius: PANEL.radius.input,
  mb: 0.5,
  display: "flex",
  justifyContent: "space-between",
  px: 1.5,
  py: 0.75,
  border: `1px solid transparent`,
  "&:hover": {
    bgcolor: PANEL.accent.soft,
    borderColor: PANEL.accent.softBorder22,
  },
};

export const panelFieldSelectSubheaderSx = {
  bgcolor: "transparent",
  color: PANEL.accent.text,
  fontWeight: 700,
  fontSize: "0.75rem",
  letterSpacing: "0.04em",
  textTransform: "none",
  lineHeight: "32px",
  px: 1,
};

export const panelFieldSelectAccordionSx = (level = 0) => {
  const surfaces = [PANEL.surface, PANEL.fill.muted, PANEL.pageBg];
  return {
    bgcolor: surfaces[Math.min(level, surfaces.length - 1)],
    mb: 1,
    borderRadius: `${PANEL.radius.cardMd} !important`,
    border: `1px solid ${PANEL.border}`,
    boxShadow: "none",
    overflow: "hidden",
    "&:before": { display: "none" },
    "&.Mui-expanded": { margin: "0 0 8px 0" },
  };
};

export const panelFieldSelectTabsWrapSx = {
  borderBottom: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
};

export const panelFieldSelectSearchWrapSx = {
  p: 2,
  bgcolor: PANEL.pageBg,
};

export const panelFieldSelectListWrapSx = {
  flex: 1,
  overflowY: "auto",
  px: 2,
  pb: 2,
};

export const panelFieldSelectEmptySx = {
  p: 2,
  textAlign: "center",
  color: PANEL.text.muted,
  fontSize: "0.875rem",
};

export const panelFieldSelectExpandIconSx = {
  color: PANEL.text.muted,
};

export const panelFieldSelectAccordionSummarySx = {
  minHeight: 48,
  "& .MuiAccordionSummary-content": {
    alignItems: "center",
    gap: 1,
    my: 0.75,
  },
};

export const panelFieldSelectAccordionIconSx = {
  color: PANEL.accent.text,
  fontSize: 20,
  flexShrink: 0,
};

export const panelFieldSelectAccordionTitleSx = {
  fontWeight: 700,
  color: PANEL.text.primary,
  fontSize: "0.875rem",
  lineHeight: 1.4,
};

export const panelFieldSelectContentSx = {
  p: 0,
  display: "flex",
  flexDirection: "column",
  height: "60vh",
  bgcolor: PANEL.pageBg,
  borderTop: "none",
  borderBottom: "none",
};
